// Kept as a re-export for backward compatibility.
// The cart sheet is small and its state is needed immediately (badge count,
// open/close from other UI). Lazy-loading it was delaying the root hydration
// and swallowing early clicks on the hero search form. Load eagerly.
import { CartSheet } from "./CartSheet";

export const LazyCartSheet = () => <CartSheet />;
